<script lang="ts" setup>
import { NavigationMenuLink } from 'reka-ui';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
</script>

<template>
  <li class="flex flex-col gap-y-16">
    <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.resource.title') }}</div>

    <ul class="m-0 w-328 flex flex-col list-none gap-y-16 p-0 <lg:w-full">
      <li>
        <NavigationMenuLink href="https://xiaoyuanxing.openatom.cn/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          {{ $t('header.resource.item1.title') }}
        </NavigationMenuLink>
      </li>
      <li>
        <NavigationMenuLink href="https://competition.openatom.tech/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          {{ $t('header.resource.item2.title') }}
        </NavigationMenuLink>
      </li>
      <li>
        <NavigationMenuLink href="https://openatom.cn/law" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          {{ $t('header.resource.item3.title') }}
        </NavigationMenuLink>
      </li>
      <li v-if="locale === 'zh-CN'">
        <NavigationMenuLink href="https://openatom.cn/certification/index" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          开源人才认证
        </NavigationMenuLink>
      </li>
      <li v-if="locale === 'zh-CN'">
        <NavigationMenuLink href="https://talent.openatom.cn/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          开源人才评价
        </NavigationMenuLink>
      </li>
      <li>
        <NavigationMenuLink href="https://openatom.cn/conference/2026-2/index/main/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
          {{ $t('header.resource.item6.title') }}
        </NavigationMenuLink>
      </li>
    </ul>
  </li>
</template>
